import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  signal,
  inject,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NavBar } from './nav-bar/nav-bar';
import { TitleBar } from './title-bar/title-bar';
import { FontSize } from './font-size-picker/font-size-picker';
import { languages, DEFAULT_LOCALE } from './locales/languages';
import { TransferredAccountService } from './services/transferred-account.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavBar, TitleBar],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements OnInit {
  protected readonly title = signal('CE.Anthem.Hns.Ui.Angular');
  protected locale: string = DEFAULT_LOCALE;
  protected fontSizeClass = 'font-medium';

  private readonly translate = inject(TranslateService);
  private readonly transferredAccountService = inject(TransferredAccountService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    // Set up available languages
    this.translate.addLangs(languages.map(lang => lang.Code));
    this.translate.setFallbackLang(DEFAULT_LOCALE);

    // Check for language override via URL query parameter (e.g. ?lang=es)
    const langParam = new URLSearchParams(window.location.search).get('lang');
    if (langParam && languages.some(lang => lang.Code === langParam)) {
      this.locale = langParam;
    }

    // Use the locale (will load the translation file)
    this.translate.use(this.locale);

    // Start listening for account data from the other app
    this.transferredAccountService.startListening();

    // Register cleanup callback
    this.destroyRef.onDestroy(() => {
      this.transferredAccountService.stopListening();
    });
  }

  handleLanguageChange(locale: string): void {
    this.locale = locale;
    this.translate.use(this.locale);
  }

  handleFontSizeChange(size: FontSize): void {
    this.fontSizeClass = `font-${size}`;
  }
}
